import Layout from 'Layout'
import './style.scss'
import { mixGetV1 } from 'services/mixin';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const StarNameMap = [
  { code: "RI", key: "maturity", short: "mat" },
  { code: "CMI", key: "balance", short: "bal" },
  { code: "ARI", key: "rational_thinking", short: "rat_th" },
  { code: "PPAI", key: "link_connection", short: "link_conn" },
  { code: "PPA", key: "life_path", short: "lpath" },
  { code: "SPI", key: "life_purpose", short: "lpurpose" },
  { code: "NEI", key: "birth_day", short: "bday" },
  { code: "EDI", key: "soul", short: "soul" },
  { code: "SSI", key: "subconscious_strength", short: "sub_str" },
  { code: "MPI", key: "personality", short: "pers" },
  { code: "IOCI", key: "soul_personality_link", short: "soul_pers_link" },
  { code: "WMI", key: "missing_aspects", short: "miss_aspects" },
  { code: "SAI", key: "passion", short: "pass" },
  { code: "TCI1", key: "milestone_1", short: "mile1" },
  { code: "TCI2", key: "milestone_2", short: "mile2" },
  { code: "TCI3", key: "milestone_3", short: "mile3" },
  { code: "TCI4", key: "milestone_4", short: "mile4" },
  { code: "BCI1", key: "challenge_1", short: "chall1" },
  { code: "BCI2", key: "challenge_2", short: "chall2" },
  { code: "BCI3", key: "challenge_3", short: "chall3" },
  { code: "BCI4", key: "challenge_4", short: "chall4" },
  { code: "AMI", key: "alignment_signals", short: "align_pyear" },
  { code: "CII", key: "societal_adaptability_index", short: "soc_adapt" },
]

const DetailStar = () => {
  const { slug, id } = useParams<{ slug: string; id: string }>();
  const [data, setData] = useState<{ title: string; content: string }>({ title: "", content: "" })
  const { t } = useTranslation();
  const navigate = useNavigate()
  const getData = async () => {
    try {
      const slugFormat = StarNameMap.find(item => item.code === slug);
      const res = await mixGetV1(
        `/api/v1/be/numerology_indices?key=${slugFormat?.key}&number=${id}&locale=en&page=1&limit=1`
      )

      if (res.status) {
        const userData = localStorage.getItem('user');

        if (userData) {
          const user = JSON.parse(userData);

          const handledTitle = user.language === 'en' ? JSON.parse(res.data.items[0].title).en : JSON.parse(res.data.items[0].title).vi
          const handledContent = user.language === 'en' ? JSON.parse(res.data.items[0].description).en : JSON.parse(res.data.items[0].description).vi

          setData({
            title: handledTitle,
            content: handledContent
          })
        }
      }
    } catch (err) {
      console.error("Lỗi khi lấy dữ liệu:", err)
    }
  }

  useEffect(() => {
    getData()
  }, [slug, id])

  return (
    <Layout>
      <Link to={'..'}
        onClick={(e) => {
          e.preventDefault();
          navigate(-1);
        }}
      >
        <button className="btn-back bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded inline-flex gap-2 items-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#000000" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
          {t('Back')}
        </button>
      </Link>
      {data.title && <div className="content">
        <h3>{data.title}</h3>
        <div className='content-full-box' dangerouslySetInnerHTML={{ __html: data.content }} />
      </div>}
      {!data.title && <p>Updating information ...</p>}
    </Layout>
  )
}

export default DetailStar